import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import BorderedButton from '../../../components/BorderedButton';

interface MobileProps {
  mobile?: boolean;
}

const ActivateBenefitContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${themes.colors.KBPalePink};
  height: 180px;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 20px;

  ${({ mobile }: MobileProps) => `
    width: ${mobile ? '100%' : '230px'};
  `}
`;

const ActivateBenefitText = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-size: 14px;
  color: ${themes.colors.KBNight};
  text-align: center;
  padding-bottom: 20px;
`;

const ActivateBenefitBox = (props: {
  onActivateBenefitPress: (e: MouseEvent) => void;
  mobile: boolean;
}) => {
  return (
    <ActivateBenefitContainer mobile={props.mobile}>
      <ActivateBenefitText>{'Does your employer have the Kindbody benefit?'}</ActivateBenefitText>
      <BorderedButton text={'ACTIVATE YOUR BENEFIT'} onClick={props.onActivateBenefitPress} />
    </ActivateBenefitContainer>
  );
};

export default ActivateBenefitBox;
